import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  got,
  err,
  type HistoryResultsState,
  updateStatus,
  outOfResults,
  fetchMore,
  initSearch,
  updateSort,
  updateFilters,
  resetFilter,
  resetFilters,
} from "./historySlice";
import { type HistoryItem } from "../../types";
import { RStatus } from "features/Application/types";
import { getHistoryResults } from "./historySelectors";
import { fetchHistoryResultsSearch } from "features/Account/services/historyResultsService";
import { mapToHistoryItems } from "features/Account/services/historyResultsMapperService";
import { type ContentItem } from "features/AssetResults/types";

export function* handleFetchNewHistoryResults() {
  try {
    const state: HistoryResultsState = yield select(getHistoryResults);
    const { search } = state;
    const { appliedFilters, sortType } = search;
    const searchResults: HistoryItem[] = yield call(fetchHistoryResultsSearch, appliedFilters, sortType);

    const searchItems: ContentItem[] = mapToHistoryItems(searchResults);

    yield call(testForOutOfResults);
    yield put(got({ items: searchItems }));
  } catch (error: any) {
    yield put(err({ errorMessage: error?.message }));
  }
}

export function* handleFetchMoreHistoryResults() {
  try {
    const state: HistoryResultsState = yield select(getHistoryResults);
    const { search, reachedEnd, items } = state;
    const { appliedFilters, sortType } = search;
    if (reachedEnd && items) {
      yield put(updateStatus({ status: RStatus.Got }));
      return;
    }
    const historyResults: HistoryItem[] = yield call(fetchHistoryResultsSearch, appliedFilters, sortType);

    const historyItems = mapToHistoryItems(historyResults);

    yield call(testForOutOfResults);
    yield put(got({ items: items.concat(historyItems) }));
  } catch (error: any) {
    yield put(err({ errorMessage: error?.message }));
  }
}

export function* testForOutOfResults() {
  yield put(outOfResults());
}

export function* historyWatcherSaga() {
  yield takeLatest(fetchMore.type, handleFetchMoreHistoryResults);
  yield takeLatest(
    [initSearch.type, updateSort.type, updateFilters.type, resetFilter.type, resetFilters.type],
    handleFetchNewHistoryResults,
  );
}
